import { type ResponseValues } from 'axios-hooks';

import type Paginated from '@/app/core/paginable';
import { useGetApplication } from '@/app/hooks';

import { type PaymentsReceived } from '../models/Payment';

const BaseUrlTaxReturnPayment = '/taxreturnpayments';

export const useGetPaymentsReceived = (
  id: string,
  ignoreDefaultLang?: boolean
): ResponseValues<PaymentsReceived, any, any> => {
  const [{ data, loading, error }] = useGetApplication<Paginated<PaymentsReceived>>({
    url: `${BaseUrlTaxReturnPayment}/received`,
    params: { relations: ['TaxCollector'], page: 1, perPage: 1, id },
    headers: ignoreDefaultLang ? { lang: true } : undefined
  });
  const [payments] = data?.data || [];

  return { data: payments, loading, error };
};
